"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countryIsEea = void 0;
const idsOfCountriesInEea = new Set([
    "1", "27", "24", "12", "2", "3", "4", "5",
    "6", "7", "8", "9", "10", "11", "13", "14", "15",
    "16", "17", "19", "20", "21", "25", "26", "31",
    "33", "34", "35", "38", "41", "47",
]);
const countryIsEea = (id) => {
    return idsOfCountriesInEea.has(id);
};
exports.countryIsEea = countryIsEea;
//# sourceMappingURL=country-is-eea.js.map